/**
 * Rental fee maths (t1366). `feeCents` on a rental is the RATE per period;
 * for `daily`/`weekly` rentals with a due date the amount charged is the rate
 * times the number of periods between start and due date. Everything else
 * (one-time, monthly, open-ended) is a single period — the fee as typed.
 */
const MS_PER_DAY = 86_400_000;
function dayNumber(date) {
    return Math.floor(Date.parse(`${date.slice(0, 10)}T00:00:00Z`) / MS_PER_DAY);
}
/** Calendar days from start to due, at least 1. */
export function rentalDays(startDate, dueDate) {
    const days = dayNumber(dueDate) - dayNumber(startDate);
    return Number.isFinite(days) ? Math.max(1, days) : 1;
}
/** How many billed periods the rental spans. */
export function rentalFeePeriods(r) {
    if (!r.dueDate)
        return 1;
    if (r.billingInterval === 'daily')
        return rentalDays(r.startDate, r.dueDate);
    if (r.billingInterval === 'weekly')
        return Math.ceil(rentalDays(r.startDate, r.dueDate) / 7);
    return 1;
}
/** The total fee for the whole rental. */
export function rentalFeeTotalCents(r) {
    return r.feeCents * rentalFeePeriods(r);
}
/** The unit a daily/weekly/monthly rate is "per"; null for one-time. */
export function rentalIntervalUnit(interval) {
    return interval === 'daily'
        ? 'day'
        : interval === 'weekly'
            ? 'week'
            : interval === 'monthly'
                ? 'month'
                : null;
}
const LABELS = {
    one_time: 'One time',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
};
export function rentalIntervalLabel(interval) {
    return LABELS[interval] ?? interval;
}
//# sourceMappingURL=rental-fee.js.map